import { useState, useEffect } from 'react';

const THEME_COOKIE_NAME = 'themeToken';

const getCookieValue = (name) => {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : null;
};

const useTheme = () => {
  const getTheme = () => {
    if (typeof window === 'undefined') return 'dark';

    const cookieValue = getCookieValue(THEME_COOKIE_NAME);
    if (cookieValue === 'light' || cookieValue === 'dark') {
      return cookieValue;
    }

    return document.documentElement.getAttribute('theme') || 'dark';
  };

  const [theme, setTheme] = useState('dark');

  useEffect(() => {
    const detectedTheme = getTheme();
    setTheme((prev) => (prev !== detectedTheme ? detectedTheme : prev));
  }, []);

  useEffect(() => {
    const html = document.documentElement;
    html.setAttribute('theme', theme);
    html.classList.remove('theme-light', 'theme-dark');
    html.classList.add(`theme-${theme}`);
  }, [theme]);

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const newTheme = getTheme();
      setTheme((prev) => (prev !== newTheme ? newTheme : prev));
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['theme'],
    });

    return () => observer.disconnect();
  }, []);

  return { isLight: theme === 'light' };
};

export default useTheme;
